
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import SearchDate from '~/components/Common/UI/Search/SearchDate'
import { SlashNConverter } from '~/utils/'
import api from '~/api/'
export default {
    components: {
        SearchDate,
    },
    data() {
        return {
            newsType: 'MENU_STOCK_SB',
            dataList: '',
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),
    },
    watch: {
        getSearch() {
            this.getList()
        },
    },
    created() {
        this.getList()
    },

    methods: {
        /* 20210517 shb 작성 당일 및 6개월 사이 검색 */
        getTodayASixdateAgo() {
            const now = new Date()
            const y = now.getFullYear() // 년
            const month = new Date(now.setMonth(now.getMonth() + 1))
            const m =
                month.getMonth() >= 10
                    ? month.getMonth()
                    : '0' + month.getMonth() // 월
            const d = now.getDate() // 날짜
            const sixDateAgo = new Date(now.setMonth(month.getMonth() - 6))
            const sy = sixDateAgo.getFullYear() // 년
            const sm =
                sixDateAgo.getMonth() >= 10
                    ? sixDateAgo.getMonth()
                    : '0' + sixDateAgo.getMonth() // 월
            const sd = sixDateAgo.getDate() // 날짜

            return { startDate: `${sy}${sm}${sd}`, endDate: `${y}${m}${d}` }
        },
        async getList() {
            const params = {
                menuType: this.newsType,
                ...this.getTodayASixdateAgo(),
                // ...this.getSearch,
            }
            const res = (await api.getStockFirmOpinionAndStrongBuying(params))
                .data
            this.dataList = res.items

            res.items.sort(function (a, b) {
                return b.showDate - a.showDate
            })

            if (res.items) {
                this.dataList.forEach((element) => {
                    element.content = SlashNConverter(element.content)
                })
            }
        },
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
    },
}
